/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetOrganicVolumeOptions,
  GetOrganicVolumeStatus200,
  GetOrganicVolumeStatus400,
  GetOrganicVolumeStatus403,
  GetOrganicVolumeStatus500,
} from '../types/GetOrganicVolume'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getOrganicVolume } from '../clients/getOrganicVolume'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getOrganicVolumeQueryKey = ({
  query,
}: Omit<GetOrganicVolumeOptions, 'headers'> = {}) =>
  [{ url: '/v1/organic-traffic/volume' }, ...(query ? [query] : [])] as const

type GetOrganicVolumeQueryKey = ReturnType<typeof getOrganicVolumeQueryKey>

export function getOrganicVolumeQueryOptions(
  { query }: GetOrganicVolumeOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getOrganicVolumeQueryKey({ query })
  return queryOptions<
    GetOrganicVolumeStatus200,
    ResponseErrorConfig<
      GetOrganicVolumeStatus400 | GetOrganicVolumeStatus403 | GetOrganicVolumeStatus500
    >,
    GetOrganicVolumeStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getOrganicVolume({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Admin only. Reports the USD notional traded by users who are not bots, broken down by asset or by tenant. Fills on books quoted in a non-currency asset have no USD notional and are left out.
 * @summary Report organic trading volume
 * {@link /v1/organic-traffic/volume}
 */
export function useGetOrganicVolume<
  TData = GetOrganicVolumeStatus200,
  TQueryData = GetOrganicVolumeStatus200,
  TQueryKey extends QueryKey = GetOrganicVolumeQueryKey,
>(
  {
    query,
  }: { query?: GetOrganicVolumeOptions['query'] | (() => GetOrganicVolumeOptions['query']) } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetOrganicVolumeStatus200,
        ResponseErrorConfig<
          GetOrganicVolumeStatus400 | GetOrganicVolumeStatus403 | GetOrganicVolumeStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getOrganicVolumeQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getOrganicVolumeQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetOrganicVolumeStatus400 | GetOrganicVolumeStatus403 | GetOrganicVolumeStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
